module.exports = __webpack_public_path__ + "9addee801d59f31952f2857dcfc053e8.png";